import React, { Fragment, useEffect, useState } from 'react'
import { Table, TableHead, TableBody, Panel, PanelHeader, PanelFooter, Modal, Search } from '../../shared'
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import {
  getCustomers,
  createCustomer,
  validateInputs,
  selectCustomer,
  setCustomer,
  clearForm,
  updateCustomer,
  deleteCustomer
} from './customer-slice'
import { Autocomplete, Button } from '../../ui-components'
import {CloseIcon, PlusIcon, EditIcon} from "../../assets";
import {togglePopover} from "../../admin/app-slice";
import CustomerForm from "./customer-form";
import styles from './customer.module.scss'
import { CITIES } from '../../services/constants'

const Customer = () => {
  const dispatch = useAppDispatch()
  const app = useAppSelector(state => state.adminApp)
  const {form, customers, customer} = useAppSelector(state => state.customer)
  const head = ['id', 'Имя', 'Телефон', 'Почта', 'Адрес', 'Город', '']
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false)
  const [searchQuery, setSearchQuery] = useState<string>('')
  const [customerList, setCustomerList] = useState<any[]>([])
  const [selectedRegion, setSelectedRegion] = useState<string>('Все')
  useEffect(() => {
    dispatch(getCustomers())
      .then(res => {
        if(res && res.length) {
          setCustomerList(res)
        }
      })
  }, [dispatch])

  useEffect(() => {
    handleSelectRegion(selectedRegion)
  }, [customers])

  const submitForm = () => {

    for (const k in form) {
      dispatch(validateInputs({key: k, value: form[k]}))
    }

    if(customer){
      return dispatch(updateCustomer())
        .then((res) => {
          if (res && res.length) {
            setCustomerList(res)
          }
        } )
    }
    return dispatch(createCustomer())
  }

  const closePopover = () => {
    dispatch(setCustomer(null))
    dispatch(clearForm())
    dispatch(togglePopover('customerAddOrganization'))
  }

  const deleteOrg = async (organization) => {
    dispatch(clearForm())
    dispatch(setCustomer(null))
    dispatch(deleteCustomer(organization.uuid)).then(res => {
      if (res.deleted) {
        setDeleteModalOpen(false)
        dispatch(togglePopover('customerAddOrganization'))
        dispatch(getCustomers())
      }
    })
  }

  const rows = customerList.map((val: any) => {
    if(!val.deleted) {
      return (
        <div className='row' key={val.id}>
          <div className='item'>
            {val.id}
          </div>
          <div className='item' title={val.name}>
            <strong>{val.name}</strong>
          </div>
          <div className='item' title={val.primary_phone}>
            {val.primary_phone}
          </div>
          <div className='item' title={val.email}>
            {val.email}
          </div>
          <div className='item' title={val.address}>
            {val.address}
          </div>
          <div className='item' title={val.city}>
            {val.city}
          </div>
          <div className='item'>
            <EditIcon onClick={() => {
              dispatch(selectCustomer(val))
              dispatch(togglePopover('customerAddOrganization'))
            }}/>
          </div>
        </div>
      )
    }
  })

  const filterChange = (value: string, selectedCity = '') => {
    if (value) {
      setSearchQuery(value)
      const city = selectedCity || selectedRegion
      // @ts-ignore
      const searchedValue = customers.filter(h => h.name.toLowerCase().includes(value.toLowerCase()) || h.primary_phone.includes(value))
      setCustomerList(city !== 'Все' ? searchedValue.filter(h => h.city === city) : searchedValue)
    } else {
      setSearchQuery('')
      setCustomerList(customers)
    }
  }

  const handleSelectRegion = (value) => {
    setSelectedRegion(value)
    // @ts-ignore
    setCustomerList(value !== 'Все' ? customers.filter(h => h.city === value) : customers)
    if (searchQuery) {
      filterChange(searchQuery, value)
    }
  }

  const popoverTitle = customer ? 'Сохранить' : 'Создать'

  return (
    <Fragment>
      <div id={styles.customerList}>
        <div className={'mb-20 space-between d-flex'}>
          <Autocomplete className={styles.search}
                        options={CITIES}
                        isClearable={false}
                        value={selectedRegion}
                        label={'Регион'}
                        onChange={(data) => handleSelectRegion(data.value)}
                        optionLabel={'value'}
                        optionValue={'value'}/>
          <div className={'flex-end d-flex full-width'}>
          <Search handleChange={e => {
            filterChange(e.target.value)
          }} value={searchQuery}/>
          <Button type='contained'
                  color='secondary'
                  onClick={() => dispatch(togglePopover('customerAddOrganization'))}
                  startIcon={<PlusIcon/>}>Добавить</Button>
        </div>
        </div>
        <Table>
          <TableHead>
            {head.map((el, i) => <div className='item' key={i}>{el}</div>)}
          </TableHead>
          <TableBody>
            {rows}
          </TableBody>
        </Table>
      </div>
      <Panel open={app.customerAddOrganization}
             handleClose={() =>closePopover()}>
        <PanelHeader className='simple-header'>
          <p>{popoverTitle} физ. лицо</p>
          <CloseIcon onClick={() => closePopover()}/>
        </PanelHeader>
        <CustomerForm customer={customer}/>
        <PanelFooter className='action-box'>
          {customer && <Button type='contained' onClick={() => setDeleteModalOpen(true)} className='ml-20'>Удалить</Button>}
          <Button type='simple' onClick={() => closePopover()}>Отмена</Button>
          <Button type='contained' onClick={submitForm} className='ml-20'>{popoverTitle}</Button>
        </PanelFooter>
      </Panel>
      <Modal open={deleteModalOpen}
             closeIcon
             title={'Удалить физ лицо?'}
             handleClose={() => {
               setDeleteModalOpen(false)
             }}>
        <p className="modalText mb-50">Вы уверены, что хотите удалить физ лицо?</p>
        <div className='d-flex space-between'>
          <Button type='contained'
                  fullWidth
                  onClick={() => deleteOrg(customer)}>Да</Button>
          <Button className={`ml-30`}
                  fullWidth
                  type='outlined'
                  onClick={() => setDeleteModalOpen(false)}>Нет</Button>
        </div>
      </Modal>
    </Fragment>
  )
}

export default Customer
